import { render } from "./CmsProductHistorySelector.vue?vue&type=template&id=30bfa75c&scoped=true"
import script from "./CmsProductHistorySelector.vue?vue&type=script&lang=js"
export * from "./CmsProductHistorySelector.vue?vue&type=script&lang=js"

import "./CmsProductHistorySelector.vue?vue&type=style&index=0&id=30bfa75c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bfa75c"]])

export default __exports__